// extracted by mini-css-extract-plugin
module.exports = {"flex":"gISJ6O5V","header":"fPaSZwFR","sectionTitleWrapper":"vpH4tqvm","styledButtonGroup":"dsNF6Xf5"};